import { get_token, get_user_details} from "@/router";
import Swal from 'sweetalert2';

export default {
    name: 'FolderView',
    props:{

        folder: Object
  
    },
    mounted(){
      this.user_details = get_user_details();
          this.token_exists = get_token();
          this.user_id = this.get_user_id();
      this.fetch_document_warehouse_folders();
    },
    data() {
      return ({
        folders: [],
        currentFolderName: '',
        selectedSubfolder: null,
        isLoading: false,
        permission_types: [],
        permission_map: {},
        selected_folder: {},
        folder_permissions: [],
      });   
    },
    watch: {
      folderId: {
        immediate: true,
        handler(newId) {
          if (newId !== undefined && newId !== null) {
            this.fetch_document_warehouse_folders(newId);
          }
        }
      }
    },
    methods: {
      getToken() {
        return get_token();
      },
      get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
      openFolder() {
        this.$emit('open-folder', this.folder);
      }
      ,
      fetch_document_warehouse_folders(newId) {
        if (!newId) {
          console.warn("Invalid folder ID", newId);
          return;
        }

        const payload = {
          portal_id: this.$route.params.portal_id,
          parent_folder_id: newId
        }

        const params = new URLSearchParams(payload).toString();
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_information/?${params}`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (response) => {
            this.folders = response.data;
            // Optionally update the folder name if available
            if (response.data.length > 0) {
              this.currentFolderName = response.data[0].parent_folder_name || '';
            } else {
              this.currentFolderName = 'Empty Folder';
            }

            setTimeout(() => {

              this.loading = false;
            }, 1000);
          },
          error: (xhr) => {
            let errorMessage = 'An unexpected error occurred.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
              showConfirmButton: false,
              timer: 2000
            });
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      },
      openSubfolder(folder) {
        this.selectedSubfolder = folder;
      },
      delete_folder(folder_id) {
        const payload = {
          folder_id: folder_id,
        };
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_folder/`,
          method: 'POST',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(payload),
          success: (data) => {
            if (data.status === "success") {
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Folder deleted.',
                showConfirmButton: false,
                timer: 1000
              }).then(() => {
                Swal.close();
                this.$emit('folder-deleted', folder_id);


              });
            }
          },
          error: (xhr) => {
            let errorMessage = 'An unexpected error occurred.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
              errorMessage = xhr.responseJSON.message;
            }
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
              showConfirmButton: false,
              timer: 2000
            });
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      },

      get_permissions_types() {
        this.token_exists = get_token();

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_permissions/`,
          method: "GET",
          headers: this.token_exists
            ? {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            }
            : {},
          success: (response) => {
            this.permission_types = response.permission_types;

            this.permission_types.forEach(perm => {
              this.permission_map[perm.name.toLowerCase()] = perm.id;
            });
          },
          complete: () => {
            this.isLoading = false;
          },
        });

      },

      get_folder_permissions(folder_id) {
        this.token_exists = get_token();

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_folder_permissions/?folder_id=${folder_id}`,
          method: "GET",
          headers: this.token_exists
            ? {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            }
            : {},
          success: (response) => {

            const raw_permissions = response.folder_permissions;

            const portal_member = this.members
            const grouped = new Map();
            raw_permissions.forEach(perm => {
              const user_id = perm.portal_access.id
              const permission_name = perm.permission?.name.toLowerCase();

              if(!['view', 'edit', 'delete'].includes(permission_name)) return;
              if (!grouped.has(user_id)) {
                grouped.set(user_id, {
                  portal_access: perm.portal_access,
                  view: false,
                  edit: false,
                  delete: false
                })
              }

              const user_permissions = grouped.get(user_id);
              user_permissions.set(permission_name, true);

            });

            const final_permissions = portal_member.map(member => {
              return grouped.get(member.id) || {
                portal_access: member,
                view: false,
                edit: false,
                delete: false,
                is_owner: false
              };
            })

            this.folder_permissions = final_permissions;
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      },

      fetch_portal_members(callback) {
        this.isLoading = true;
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
          method: "GET",
          data: { portal_id: this.$route.params.portal_id },
          headers: {
            "Authorization": `Token ${this.getToken()}`,
            "Content-Type": "application/json"
          },
          success: (response) => {

            if (response.status === "success") {
              this.members = response.data.members;
            }
            if (callback) callback();
          },
          error: (xhr) => {
            if (xhr.status === 403) {
              this.$router.push("/");
              Swal.fire({
                icon: "error",
                title: "Access Denied",
                text: "You are not authorized to be in this portal.",
                showConfirmButton: false,
                timer: 3000
              });
            }
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      },

      manage_folder_permissions(folder_id) {

        this.fetch_portal_members(() => {
          this.get_folder_permissions(folder_id);

          $('#manage_folder_permissions_modal').modal('show');
        })


      },

      save_folder_permissions() {
        this.folder_permissions.forEach(user => {
          if(user.is_owner) return;
          const permission_type_ids = [];

          if (user.view) permission_type_ids.push(this.permission_map.view);
          if (user.edit) permission_type_ids.push(this.permission_map.edit);
          if (user.delete) permission_type_ids.push(this.permission_map.delete);
          if (user.create) permission_type_ids.push(this.permission_map.create);

          if (permission_type_ids.length === 0) return; // skip if no permissions

          const payload = {
            folder_id: this.folder.id ,
            portal_member_ids: [user.portal_access.id],
            permission_type_ids: permission_type_ids
          };

          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/set_folder_permissions/`,
            method: "POST",
            headers: {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            },
            data: JSON.stringify(payload),
            success: () => {
              Swal.fire("Success", "Permissions Set Successfully", "success");
        $('#manage_folder_permissions_modal').modal('hide');
            },
            error: (xhr) => {
              console.error(`Failed to save for ${user.portal_access.email}`, xhr.responseJSON);
            }
          });
        });


      }
    }
  };